
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "EIlis",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/EIlis.vue